<!-- 전역에서 사용할 컨펌 컴포넌트 -->
<template>
  <AppUILayoutModal
    v-model:show="confirm.isShow"
    :top-zero="true"
    :control-parent-click="confirm.isRequiredUpdateModal"
  >
    <div class="layout global-confirm-dialog">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V12ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill="#C4C4C4"
        />
      </svg>
      <div class="flex flex-col gap-[2px] w-full">
        <p v-if="confirm.highlightText" class="highlight-text w-full">
          {{ confirm.highlightText }}
        </p>
        <p class="message">
          {{ confirm.message }}
        </p>
      </div>
      <div class="btns" :class="{ '!justify-center': !confirm.cancelText }">
        <AppUIButton
          v-if="confirm.cancelText"
          class="secondary"
          size="md"
          :text="confirm.cancelText"
          @click="confirm.onCancel"
        />
        <AppUIButton
          class="primary"
          size="md"
          :text="confirm.confirmText"
          :class="{ '!max-w-[130px]': !confirm.cancelText }"
          @click="confirm.onConfirm"
        />
      </div>
    </div>
  </AppUILayoutModal>
</template>
<script lang="ts" setup>
  import { App } from '@/app'
  const confirm = App.confirmInstance.get()
</script>
<style lang="scss" scoped>
  .layout {
    display: flex;
    width: 320px;
    max-height: fit-content;
    padding: 30px;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    border-radius: 12px;
    border: 1px solid var(--Gray-300);
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.16);
    backdrop-filter: blur(30px);
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 12px;
      > h4 {
        margin: 0;
        color: #8a97b2;
        font-feature-settings:
          'liga' off,
          'clig' off;
        font-size: 12px;
        font-weight: 600;
      }
    }
    .highlight-text {
      font-size: 16px;
      font-weight: 700;
      text-align: center;
      color: var(--Primary-500);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
    .message {
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      color: #4d5969;
      white-space: pre-line;
    }
    > .btns {
      padding-top: 16px;
      display: flex;
      align-items: center;
      gap: 6px;
      align-self: stretch;
      justify-content: flex-end;
      > * {
        flex: 1;
      }
    }
  }
</style>
